import { Http } from './http';
import { SyntageProfile } from '@types';

class SyntageHttp extends Http {

  prefix = 'syntage';

  async getProfileByUserId(userId: number): Promise<SyntageProfile | null> {
    const res = await this.get<SyntageProfile | null>(`/profile-by-user/${userId}`);

    return res.data;
  }

  async rfcChange(userId: number): Promise<SyntageProfile> {
    const res = await this.post<SyntageProfile>(`/rfc-change/${userId}`);

    return res.data;
  }

  async ciecChange(userId: number): Promise<SyntageProfile> {
    const res = await this.post<SyntageProfile>(`/ciec-change/${userId}`);

    return res.data;
  }

  async createProfile(userId: number): Promise<SyntageProfile> {
    const res = await this.post<SyntageProfile>(`/create-profile/${userId}`);

    return res.data;
  }

  async updateProfile(userId: number): Promise<SyntageProfile> {
    const res = await this.post<SyntageProfile>(`/update-profile/${userId}`);

    return res.data;
  }

  async runIncome(userId: number): Promise<SyntageProfile> {
    const res = await this.post<SyntageProfile>(`/run-income/${userId}`);

    return res.data;
  }

  async runInvoices(userId: number): Promise<SyntageProfile> {
    const res = await this.post<SyntageProfile>(`/run-invoices/${userId}`);

    return res.data;
  }

  async runClientsData(userId: number): Promise<SyntageProfile> {
    const res = await this.post<SyntageProfile>(`/run-clients-data/${userId}`);

    return res.data;
  }

  async runExport(userId: number): Promise<SyntageProfile> {
    const res = await this.post<SyntageProfile>(`/run-export/${userId}`);

    return res.data;
  }
}

export const syntageHttp = new SyntageHttp();

